module.exports = __webpack_public_path__ + "static/media/Aleman_result.7a2783d0.jpg";